// src/api/contratoServicio.js
import { apiFetch } from './index.js';

// ============================================================
//  CRUD CONTRATO SERVICIO
// ============================================================

export const obtenerContratos = async () => {
  try {
    const response = await apiFetch('/api/ContratoServicio');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    console.error('❌ Error obteniendo contratos:', error);
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerContratosActivos = async () => {
  try {
    const response = await apiFetch('/api/ContratoServicio/activos');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerContratoPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/ContratoServicio/${id}`);
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerContratosPorServicio = async (idServicioPublico) => {
  try {
    const response = await apiFetch(`/api/ContratoServicio/servicio/${idServicioPublico}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerContratosPorSede = async (idSede) => {
  try {
    const response = await apiFetch(`/api/ContratoServicio/sede/${idSede}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const crearContrato = async (data) => {
  try {
    const response = await apiFetch('/api/ContratoServicio', {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const actualizarContrato = async (id, data) => {
  try {
    const response = await apiFetch(`/api/ContratoServicio/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const eliminarContrato = async (id) => {
  try {
    await apiFetch(`/api/ContratoServicio/${id}`, { method: 'DELETE' });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const verificarNumeroContrato = async (numero, excludeId = null) => {
  try {
    const url = excludeId
      ? `/api/ContratoServicio/numero/${encodeURIComponent(numero)}/exists?excludeId=${excludeId}`
      : `/api/ContratoServicio/numero/${encodeURIComponent(numero)}/exists`;
    const response = await apiFetch(url);
    return { success: true, existe: response.existe || false };
  } catch (error) {
    return { success: false, error: error.message, existe: false };
  }
};

// ============================================================
//  CONSTANTES Y HELPERS DE UI
// ============================================================

/**
 * Periodicidad de contratos (fijo en el sistema)
 */
export const PERIODICIDADES = [
  { value: 'mensual', label: 'Mensual' },
  { value: 'bimestral', label: 'Bimestral' },
  { value: 'trimestral', label: 'Trimestral' },
  { value: 'semestral', label: 'Semestral' },
  { value: 'anual', label: 'Anual' }
];

export const formatearFecha = (fecha) => {
  if (!fecha) return 'N/A';
  try {
    return new Date(fecha).toLocaleDateString('es-VE', {
      year: 'numeric', month: '2-digit', day: '2-digit'
    });
  } catch {
    return fecha;
  }
};

export default {
  obtenerContratos,
  obtenerContratosActivos,
  obtenerContratoPorId,
  obtenerContratosPorServicio,
  obtenerContratosPorSede,
  crearContrato,
  actualizarContrato,
  eliminarContrato,
  verificarNumeroContrato,
  PERIODICIDADES,
  formatearFecha
};